import './index.css';
import Layout from './components/Layout';
import { UserProvider } from './context/UserContext';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
 
  return (
    <UserProvider>
      <ToastContainer autoClose={5000} limit={3} />
      <Layout />
    </UserProvider>
);
};

export default App;
